import { Component, ElementRef, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild } from "@angular/core";
import { UntypedFormControl, Validators } from "@angular/forms";
import { MatDialog } from "@angular/material/dialog";
import { SnackBarService } from "src/app/services/snack-bar.service";
import { HelperService } from "src/app/utils/helper.service";
import { EmpresaService } from "../empresa.service";
import { DialogConfirmComponent } from "../../dialogs/dialog-confirm/dialog-confirm.component";
import { EditEmpresaComponent } from "../edit-empresa/edit-empresa.component";
import { take } from "rxjs";
import { AddEmpresaComponent } from "../add-empresa/add-empresa.component";

@Component({
  selector: 'app-busca-empresa',
  templateUrl: './busca-empresa.component.html',
  styleUrls: ['./busca-empresa.component.css'],
})

export class BuscaEmpresaComponent implements OnInit, OnChanges {

  @Output() empresa = new EventEmitter<any>();
  @Input() disabled: boolean;
  @Input() isLoading: boolean;
  @Input() cadastroNovo: boolean = true;
  @Input() icon: string;
  @Input() label: string;
  @Input() appearance: string;
  @Input() inputClasses: string;
  @Input() buttonTooltip: string;
  @Input() toolTip: string;
  @Input() tooltipPosition: string;
  @ViewChild('input') inputElement: ElementRef;

  cnpjForm: UntypedFormControl;
  isProgress: boolean;

  constructor(
    private empresaService: EmpresaService,
    private dialog: MatDialog,
    private helper: HelperService,
    private snackBar: SnackBarService
  ) { }

  ngOnInit(): void {
    this.cnpjForm = new UntypedFormControl({ value: null, disabled: this.disabled }, [Validators.required, this.helper.cnpjValidator]);
  }

  public getForm() {
    return this.cnpjForm;
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.disabled && this.cnpjForm) {
      if (changes.disabled.currentValue) {
        this.cnpjForm.disable();
      } else {
        this.cnpjForm.enable();
      }
    }
  }

  getEmpresa(cnpj) {
    if (this.cnpjForm.invalid) {
      this.cnpjForm.markAsTouched();
      return;
    }
    this.isProgress = true;
    this.cnpjForm.disable();
    this.empresaService.getEmpresaByCnpj({ cnpj: cnpj })
      .subscribe((res: any) => {
        this.isProgress = false;
        this.cnpjForm.enable();
        this.inputElement.nativeElement.focus();

        // this.openUpdateEmpresaDialog(res);
        this.empresa.emit(res);
      }, error => {
        this.isProgress = false;
        this.cnpjForm.enable();
        this.inputElement.nativeElement.focus();

        if (error.status === 404) {
          this.openNewEmpresaDialog();
        } else {
          console.error(error);
          this.snackBar.showSnackBarError('Erro ao consultar empresa. Tente novamente.');
        }
      })
  }

  openUpdateEmpresaDialog(empresa) {
    const dialogRef = this.dialog.open(DialogConfirmComponent, {
      width: '540px',
      data: {
        title: 'Cadastro Novo',
        msg: 'Cadastrar nova Empresa?',
        confirmLabel: 'Sim',
        dismissLabel: 'Não'
      }
    });
    dialogRef.afterClosed()
      .pipe(take(1))
      .subscribe({
        next: (result) => {
          if (result) {
            const innerDialogRef = this.dialog.open(EditEmpresaComponent, {
              data: empresa.id
            });
            innerDialogRef.afterClosed()
              .pipe(take(1))
              .subscribe(empresa => {
                if (!empresa) {
                  this.isProgress = false;
                  this.cnpjForm.enable();
                  this.cnpjForm.reset();
                  this.inputElement.nativeElement.focus()
                  return;
                }
                this.empresaService.updateEmpresa(empresa.id, empresa)
                  .subscribe(
                    (res: any) => {
                      this.isProgress = false;
                      this.cnpjForm.enable();
                      this.cnpjForm.reset();
                      this.inputElement.nativeElement.focus();
                      let empresa = res;
                      this.empresa.emit(empresa);
                    },
                    error => {
                      this.isProgress = false;
                      this.cnpjForm.enable();
                      this.cnpjForm.reset();
                      this.inputElement.nativeElement.focus();
                      console.error(error);
                      this.snackBar.showSnackBarError('Error ao salvar nova Empresa');
                    }
                  );
              });
          } else {
            this.isProgress = false;
            this.cnpjForm.enable();
            this.cnpjForm.reset();
            this.inputElement.nativeElement.focus();
          }
        }
      });
  }

  openNewEmpresaDialog() {
    const dialogRef = this.dialog.open(DialogConfirmComponent, {
      width: '540px',
      data: {
        title: 'Confirmação',
        msg: 'CNPJ não encontrado. Deseja cadastrá-lo?',
        confirmLabel: 'Sim',
        dismissLabel: 'Não'
      }
    });

    dialogRef.afterClosed()
      .subscribe((result => {
        if (result) {
          const innerDialogRef = this.dialog.open(AddEmpresaComponent, {
            width: '800px',
            maxHeight: '90vh',
            autoFocus: false,
            data: {
              cnpj: this.cnpjForm.value
            }
          });
          innerDialogRef.afterClosed()
            .subscribe(empresa => {
              if (!empresa) {
                this.isProgress = false;
                this.cnpjForm.enable();
                this.cnpjForm.reset();
                this.inputElement.nativeElement.focus();
                return;
              }
              this.empresaService.novaEmpresa(empresa)
                .subscribe(
                  (res: any) => {
                    this.isProgress = false;
                    this.cnpjForm.enable();
                    this.cnpjForm.reset();
                    this.inputElement.nativeElement.focus();
                    let empresa = res;
                    this.empresa.emit(empresa);
                  },
                  error => {
                    this.isProgress = false;
                    this.cnpjForm.enable();
                    this.cnpjForm.reset();
                    this.inputElement.nativeElement.focus();
                    console.error(error);
                    this.snackBar.showSnackBarError('Erro ao salvar nova Empresa');
                  }
                );
            });
        } else {
          this.isProgress = false;
          this.cnpjForm.enable();
          this.cnpjForm.reset();
          this.inputElement.nativeElement.focus();
        }
      }));
  }

  keyPressSubmit(event) {
    event.key === "Enter" ? this.getEmpresa(this.cnpjForm.value) : null;
  }

  onBlur() {
    this.cnpjForm.setErrors(null);
    this.cnpjForm.updateValueAndValidity();
  }

  isFocused(a) {
    return document.activeElement === a;
  }
}
